import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getPublicCodeConfigRequest = {};
var _getPublicCodeConfigResponse = { publicCodeConfig: '_publicCodeConfig' };
var _publicCodeConfig = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixVeloAppsV1PublicCodeConfigServiceUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a PublicCodeConfig, which is a projection of a Wix Code site's public configuration data. */
export function getPublicCodeConfig(payload) {
    var _a = serializer(_getPublicCodeConfigRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPublicCodeConfigResponse, {
        _publicCodeConfig: _publicCodeConfig,
    }).fromJSON;
    function __getPublicCodeConfig(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.code.v1.public_code_config',
            method: 'GET',
            methodFqn: 'wix.velo.apps.v1.PublicCodeConfigService.GetPublicCodeConfig',
            url: resolveWixVeloAppsV1PublicCodeConfigServiceUrl({
                protoPath: '/v1/public-code-config',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPublicCodeConfig.fromReq = fromReq;
    __getPublicCodeConfig.__isAmbassador = true;
    return __getPublicCodeConfig;
}
//# sourceMappingURL=http.impl.js.map